(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);


    config.$inject = ['$provide', '$transitionsProvider'];
    function config($provide, $transitionsProvider) {
        $provide.decorator('$transitions', transitionsDecorator);

        transitionsDecorator.$inject = ['$delegate', '$injector'];
        function transitionsDecorator($delegate, $injector) {
            var hooks = $transitionsProvider.hooks || [];

            hooks
                .map($injector.get.bind($injector))
                .map(Object.entries)
                .reduce(selectMany)
                .forEach(addHooks);

            return $delegate;

            function selectMany(a, b) {
                return a.concat(b);
            }

            function addHooks(tuple) {
                tuple[1].$unhook = $delegate[tuple[0]].apply($delegate, tuple[1]);
            }
        }
    }
})();